var ResourceUnavailabilityWS = function (parent) {
  var self = this;

  AbstractWS.apply(this, arguments);

  self.dataType = 'text';
  self.name = 'ResourceUnavailabilityWS';
  self.requesting = ko.observable(false);
  self.unavailabilities = ko.observableArray([]);


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/resources';
  });


  /**
   * Adds an unavailability block for a specified resource
   *
   * @method add
   * @param {Number} resourceId
   * @param {String} start
   * @param {String} end
   * @param {String} timezone
   * @returns none
   */
  self.add = function (resourceId, start, end, timezone) {
    self.serviceURL = ko.computed(function () {
      return '/qless/api/v1/employee/resources/' + resourceId + '/unavailability';
    });

    self.method('POST');
    self.addParam('start', start);
    self.addParam('end', end);
    self.addParam('tz', timezone);

    qcal.setStatusMessage('Updating');

    self.doRequest(function () {
      qcal.editResourceAvailability(qcal.selectedResource());
    });
  };


  self.dayIsHoliday = function (dt) {
    if (!(dt instanceof moment)) {
      dt = new moment(dt);
    }

    var holiday = self.holidays().filter(function (holiday) {
      var start = moment(holiday.startTime);
      var end = moment(holiday.endTime);
      return (dt.isAfter(start) || dt.isSame(start)) && (dt.isBefore(end) || dt.isSame(end));
    });

    return holiday.length > 0;
  };


  self.delete = function (holidayId) {
    self.serviceURL = ko.computed(function () {
      return '/qless/api/v1/employee/resources/unavailability/' + holidayId + '/delete';
    });

    self.method('POST');

    qcal.setStatusMessage('Removing');

    self.doRequest(function () {
      self.get(qcal.selectedResource().id, qcal.resourceWeek()[0], qcal.resourceWeek()[1]);
      qcal.editResourceAvailability(qcal.selectedResource());
    });
  };


  /**
   * Retrieves a set of unavailabilities for a resourceId
   * with optional start and end dates
   *
   * @method get
   * @param {Number} resourceId
   * @param {Moment} start
   * @param {Moment} end
   * @returns none
   */
  self.get = function (resourceId, start, end) {
    self.method('GET');
    self.serviceURL = ko.computed(function () {
      return '/qless/api/v1/employee/resources/' + resourceId + '/unavailability';
    });

    self.clearParams();

    if (start) {
      self.addParam('start', start.format('YYYY-MM-DD') + ' 00:00:00');
    }

    if (end) {
      self.addParam('end', end.format('YYYY-MM-DD') + ' 23:59:59');
    }

    self.doRequest(self.processUnavailabilityBlocks);
  };


  self.getFullHoliday = function (Moment) {
    return self.holidays().find(function (holiday) {
      var start = new moment(holiday.startTime);
      var end = new moment(holiday.endTime);

      return (Moment.isAfter(start) || Moment.isSame(start)) && (Moment.isBefore(end) || Moment.isSame(end));
    });
  };


  self.getHoliday = function (start, end) {
    return self.unavailabilities().find(function (holiday) {
      var s = new moment(holiday.startTime);
      var e = new moment(holiday.endTime);

      return start.isSame(s) && end.isSame(e);
    });
  };


  /**
   * Returns a collection of unavailabilities that are full days
   *
   * @method holidays
   * @returns {Array}
   */
  self.holidays = ko.computed(function () {
    var cache = [];
    var holidays = self.unavailabilities().filter(function (avail) {
      var start = new moment(avail.startTime);
      var end = new moment(avail.endTime);

      if ((end.valueOf() - start.valueOf()) === 86399000 && cache.indexOf(start.valueOf()) == -1) {
        cache.push(start.valueOf());
        return true;
      }
      else return false;
    });

    return holidays;
  });


  self.isHoliday = function (model, dayIdx, hardCheck) {
    var endHour = model.pad(model.endHour(), 2);
    var endMinute = model.pad(model.endMinute(), 2);
    var startHour = model.pad(model.startHour(), 2);
    var startMinute = model.pad(model.startMinute(), 2);
    var dayNum = (dayIdx !== null && dayIdx !== undefined) ? dayIdx : qcal.availabilitySelectedDay();
    var day = qcal.resourceWeek()[dayNum];

    if (day) {
      var start = new moment(day.format('YYYY-MM-DD') + ' ' + startHour + ':' + startMinute + ':00');
      var end = new moment(day.format('YYYY-MM-DD') + ' ' + endHour + ':' + endMinute + ':59');

      var holiday = self.unavailabilities().filter(function (holiday) {
        var s = moment(holiday.startTime);
        var e = moment(holiday.endTime);
        return start.isSame(s) && end.isSame(e);
      });

      return holiday.length > 0 || (!hardCheck && self.dayIsHoliday(start));
    }
    return false;
  };


  /**
  * @method doRequest
  * @param {Function} fCallback
  * @return {ResourceWS}
  */
  self.doRequest = function () {
    if (qcal.queuesWS.allQueueIds().length > 0) {
      self.requesting(true);

      // Call the super-method
      AbstractWS.prototype.doRequest.apply(self, arguments);
    }

    return self;
  };


  /**
  * @method processData
  * @param {JSON|XMLDocument} json
  * @return {ResourceUnavailabilityWS}
  */
  self.processData = function (json) {
    var aRsrcs = [];
    var aTemp = [];
    var aTempIds = [];

    json = JSON.parse(json);

    qcal.setStatusMessage(null);

    self.reset();

    if (self.callback) {
      self.callback(json);
      self.callback = null;
    }

    qcal.initSelectable()

    return self;
  };


  self.processUnavailabilityBlocks = function (json) {
    self.unavailabilities(json.resourceUnavailability);
  }

  return self;
};



self.reset = function () {
  self.method('GET');
  self.requesting(false);

  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/resources/{resourceIds}/unavailability';
  });
};

ResourceUnavailabilityWS.prototype = AbstractWS.prototype;
ResourceUnavailabilityWS.prototype.constructor = ResourceUnavailabilityWS;

if (typeof exports !== 'undefined') {
  exports.ResourceUnavailabilityWS = ResourceUnavailabilityWS;
}
